module.exports = __webpack_public_path__ + "static/media/zocaloPvc3.99bb4dd2.jpg";